import styled from 'styled-components';

export const RadioButton = styled.div`
  cursor: pointer;
  > i {
    color: ${props => (props.checked ? '#00AB97' : '#455A64')};
  }
`;

export const Groove = styled.label`
  width: 34px;
  height: 14px;
  border-radius: 10px;
  display: inline-block;
  background-color: ${props =>
    props.theme === 'dark' ? 'rgba(255,255,255,0.30)' : 'rgba(38,50,56,0.30)'};
  position: relative;
  input {
    display: none;
  }
`;

export const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => {
    if (props.theme === 'dark') {
      return props.checked
        ? 'rgba(78,194,178,0.50);'
        : 'rgba(255,255,255,0.30);';
    }

    return props.checked ? 'rgba(0,171,151,0.50);' : 'rgba(38,50,56,0.30);';
  }};
  border-radius: 10px;
  transition: 0.1s;

  &:before {
    position: absolute;
    box-shadow:
      0 1px 6px rgba(0, 0, 0, 0.12),
      0 1px 4px rgba(0, 0, 0, 0.12);
    content: '';
    left: -2px;
    top: -2px;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    ${props => {
      if (props.checked) {
        if (props.theme === 'dark') {
          return `
            transform: translateX(20px);
            background-color: #4EC2B2;
            `;
        }
      }

      return '';
    }};
    transform: ${props =>
      props.checked ? 'translateX(20px)' : 'translateX(0)'};
    background-color: ${props => {
      if (props.checked) {
        return props.theme === 'dark' ? '#4EC2B2' : '#00AB97';
      }

      return '#F4F7F9';
    }};
  }
`;
